import React, { useContext, useState, useCallback, useEffect } from 'react'
import styled, { ThemeContext } from 'styled-components'
import { RouteComponentProps } from 'react-router-dom'
import { BigNumber } from 'bignumber.js'
import { Text } from 'rebass'

// components
import Loading from '../../components/Loader/Loading'
import Row, { AutoRow } from '../../components/Row'
import { ButtonConfirmed } from '../../components/Button'
import Loader from '../../components/Loader'
import SellComboModal from '../Restaurant/components/SellComboModal'
import {Artworks} from './components/Artworks'
import NoArtworks from '../../components/nftInfo/NoArtworks'
import AuditModal from '../BakeryArtworks/components/AuditModal'
import Player from '../../components/nftInfo/Player'
import VoteModal from '../BakeryArtworks/components/VoteModal'
import Paginator from '../../components/Paginator'
import Mark from '../Home/components/Mark'
import BiddingList from '../../components/nftInfo/BiddingList'
import TradingList from '../../components/nftInfo/TradingList'
import InfoAddress from '../../components/nftInfo/InfoAddress'
import Status from '../../components/nftInfo/Status'
import ImageBig from '../BakeryArtworks/components/ImageBig'
import Introduction from '../../components/nftInfo/Introduction'

// utils
import { getSushiAddress } from '../../sushi/utils'
import { getBalanceNumber } from '../../utils/bakery/formatBalance'
import { SortOptions, TabOptions, AuditOptions, ArtworkProps, AuctionBake, defaultArtworks } from '../../constants/artwork'
import { MARKETTYPE } from '../../constants/bakery/nft'
import { deepCopy } from '../../utils/func'

// hooks
import { useActiveWeb3React } from '../../hooks'
import { useWalletModalToggle } from '../../state/application/hooks'
import useModal from '../../hooks/bakery/useModal'
import useYam from '../../hooks/bakery/useYam'
import useTokenBalance from '../../hooks/bakery/useTokenBalance'
import useAllowanceERC20 from '../../hooks/nft/useAllowanceERC20'
import { useAddPopup } from '../../state/application/hooks'
import useInterval from '../../hooks/useInterval'
import useAllowanceERC721 from '../../hooks/nft/useAllowanceERC721'
import useApproveERC721, { GETBAKERYSOCCEREXCHANGE } from '../../hooks/nft/useApproveERC721'
import useSell from '../../hooks/nft/useSell'
import useRevokeExchange  from '../../hooks/nft/useRevokeExchange'
import useApproveERC20 from '../../hooks/nft/useApproveERC20'
import useBuy from '../../hooks/nft/useBuy'
import { useReviewAddress } from '../../hooks/launchArtworks/useContract'

import SortPets from '../Pet/components/SortPets'
import { getArtworks, auditArtworks, getArtworksV2 } from '../../service/nft'
import { useMarketLevel } from '../../state/market/hooks'

import BiddingModal from '../Artworks/components/BiddingModal'
import useBid from '../../hooks/nft/useBidding'
import useUpdateBid from '../../hooks/nft/useUpdateBid'
import useAllowanceBid from '../../hooks/nft/useAllowanceBid'
import useApproveBid from '../../hooks/nft/useApproveBid'
import useUserBids  from '../../hooks/nft/useUserBids'
import useAllowanceAll from '../../hooks/nft/useAllowanceAll'
import useApproveAllERC721 from '../../hooks/nft/useApproveAllERC721'
import useCancelBid from '../../hooks/nft/useCancelBid'
import useUserAsks  from '../../hooks/nft/useUserAsks'
import useSellTokenTo from '../../hooks/nft/useSellTokenTo'
import useAllowanceVote from '../../hooks/nft/useAllowanceVote'
import useApproveVote from '../../hooks/nft/useApproveVote'
import useVoting from '../../hooks/nft/useVoting'
import useAuction from '../../hooks/nft/useAuction'
import useMaxBidPrice from '../../hooks/nft/useMaxBidPrice'

const RowColumn = styled(Row)`
display: flex;
flex-wrap: wrap;
width: 1204px;
margin: auto;
box-sizing: border-box;
justify-content: flex-start;

${({ theme }) => theme.mediaWidth.upToBigerLarge`
  width: 904px;
`}

${({ theme }) => theme.mediaWidth.upToLarge`
  width: 628px;
`}

${({ theme }) => theme.mediaWidth.upToMedium`
  width: 605px;
`}

${({ theme }) => theme.mediaWidth.upToSmall`
  width: 100%;
  padding: 0px 20px;
  justify-content: center;
`}
`

const TabRow = styled(Row)<{margin?: string, width?: string}>`
  margin: ${({margin}) => (margin ? margin : 'auto')};
  width: ${({width}) => (width ? width : 'auto')};
  justify-content: space-between;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    margin-bottom: 15px;
    flex-direction: column;
    align-items: center;
    width: auto;
  `}
`
const TextLabel = styled.div<{width?: string, height?: number, color?: string; family?: string; size?: number; top?: string; weight?: string}>`
  width: ${({width}) => (width ? width : 'auto')};
  line-height: ${({height}) => (height ? height : 28)}px;  
  color: ${({color}) => (color)};
  font-family: ${({family}) => (family ? family : 'Baloo Da')}!important;
  font-size: ${({size}) => (size ? size : 28)}px;
  margin: ${({top}) => (top ? top : 0)};
  font-weight: ${({weight}) => (weight ? weight : 'normal')};
`
const RowColumnInfo = styled(Row)`
  padding: 48px 0;
  padding-bottom: 72px;
  align-items: flex-start;
  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    flex-direction: column;
    align-items: center;
  `}
`
const BidTrad = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`
const InfoImgLabel = styled(Row)`
  position: relative;
  margin-right: 40px;
  padding: 10px;
  width: 449px;
  /* width: 362px; */
  justify-content: center;
  flex-shrink: 0;
  height: 706px;
  border: 1px solid ${({ theme }) => theme.bsBg16};
  border-radius: 8px;
  box-sizing: border-box;
  align-items: center;
  box-sizing: border-box;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 0 0 30px;
    width: 100%;
    max-width: 361px;
  `}
`
const InfoImg = styled.img`
  max-width: 100%;
  max-height: 100%;
  border-radius: 18px;
  object-fit: contain;
  cursor: pointer;
  overflow: hidden;
`
const InfoRight = styled(RowColumn)`
  align-items: flex-start;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    align-items: center;
  `}
`
const InfoDiv = styled.div`
  width: 100%;
  padding-bottom: 48px;
  min-height: 350px;
  border-bottom: 1px dashed rgba(214, 164, 133, 0.5);
  ${({ theme }) => theme.mediaWidth.upToMedium`
    height: auto;
    min-height: auto;
  `}
`
const Button = styled(ButtonConfirmed)`
  color: ${({theme}) => theme.bsText9}; 
  padding: 0;
  border: none;
  font-size: 14px;
  width: 196px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 10px;
  align-self: flex-start; 
  ${({ theme }) => theme.mediaWidth.upToMedium`
    align-self: center; 
  `}
`
const ArtworksList = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 1204px;
  margin: auto;
  box-sizing: border-box;
  justify-content: flex-start;

  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    width: 904px;
  `}

  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 628px;
  `}

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 605px;
  `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    padding: 0px 20px;
    justify-content: center;
  `}
`
const BalanceBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  & > button {
    width: 196px;
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-wrap: wrap;
    & > button {
      margin-bottom: 10px;
    }
  `}
`
const HotRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-wrap: wrap;
    justify-content: center;
  `}
`
const VoteButton = styled(ButtonConfirmed)`
  width: 196px;
  height: 40px;
  flex-shrink: 0;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-top: 10px;
    margin-right: 16px;
  `}
`
const VoteAutoRow = styled.div`
  flex-wrap: nowrap;
  justify-content: center;
  display:flex;
  align-items:center;
`
const PriceFlag = styled.div`
  position: absolute;
  top: 0px;
  left: -6px;
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.bsBg8};
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  box-shadow: ${({ theme }) => theme.darkMode ? 'none' : '0px 2px 8px rgba(47, 20, 0, 0.74)' };
  color: ${({ theme }) => theme.bsText1};
  font-family: Baloo Da;
  font-weight: 400;
  max-width: 100%;
  height: 28px;
  padding: 0 8px;
  z-index: 1;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -6px;
    border-width: 3px;
    border-style: solid;
    border-color: ${({ theme }) => theme.bsBg9} ${({ theme }) => theme.bsBg9} transparent transparent;
  }
`

export default function ArtworkInfo ({
  match: {
    params: { tokenId, isMyArtwork, price, status }
  },
  history
}: RouteComponentProps<{ tokenId: string, isMyArtwork: string, price: string, status: string }>) {
  const NFTTYPE = 'BAKERYSOCCER'
  const level = useMarketLevel()
  const theme = useContext(ThemeContext)
  const [updateNum, setUpdateNum] = useState(1)
  const { account, chainId } = useActiveWeb3React()
  const toggleWalletModal = useWalletModalToggle()
  const [loadingFlag, setLoadingFlag] = useState(false)
  const [artwork, setArtwork] = useState({...deepCopy(defaultArtworks), tokenId: tokenId, price: price, nftType: 100})

  let noAsked = false
  if (isMyArtwork && !artwork.price) {
    noAsked = true
  }

  //授权投票
  const allowanceVote = useAllowanceVote()
  const [requestedApprovalVote, setRequestedApprovalVote] = useState(false)
  const onApproveVote = useApproveVote()
  const handleApproveVote = useCallback(async (event) => {
    try {
      setRequestedApprovalVote(true)
      const txHash = await onApproveVote()
      if (!txHash) {
        setRequestedApprovalVote(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onApproveVote, setRequestedApprovalVote])

  // 投票
  const {onVote} = useVoting(artwork.tokenId, MARKETTYPE.BAKERYSOCCER, artwork.owner) 
  const handleVote = useCallback(async (amount: string) => {
    try {
      const txHash = await onVote(amount)
      console.log('handleVote', txHash)
    } catch (e) {
      console.log(e)
    }
  }, [onVote])

  const handVote = ((event: any) => {
    onVoting()
  })

  const [onVoting] = useModal(
    <VoteModal
      onConfirm={handleVote}
      tokenId={artwork.tokenId}
      nftType={artwork.nftType}
      nftId={artwork.nftId}
      name={artwork.name}
      type={MARKETTYPE.BAKERYARTWORK}
    />
  )

  const reviewAddress: any = useReviewAddress()
  const [canReview, setCanReview] = useState((account && reviewAddress ? reviewAddress.includes(account) : false))
  useEffect(() => {
    if (account && reviewAddress) {
      setCanReview(reviewAddress.includes(account))
    }
  }, [account, chainId, reviewAddress])

  const { library } = useActiveWeb3React()
  const addPopup = useAddPopup()

  const fetchArtworkInfo = async (tokenId: string, loading?: boolean) => {
    if (loading) {
      setLoadingFlag(true)
    }
    let params = {
      nftType: 100,
      ids: `100-${tokenId}`
    }
    fetchAsksSort(params, true)
  }

  // 根据tokenId获取详情
  useEffect(() => {
    fetchArtworkInfo(tokenId, true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenId, chainId])

  // 获取列表
  const [curSelect, setCurSelect] = useState(SortOptions[0])
  const [curTab, setCurTab] = useState(TabOptions[0])
  const emptyArtworks: any[] = []
  const [artworks, setArtworks] = useState(emptyArtworks)

  const [page, setPage] = useState(1)
  useEffect(() => {
    setPage(1)
  }, [account, chainId, level])
  
  const LIMIT = 4

  const fetchAsks = async (page: number, loading?: boolean) => {
    if (loading) {
      setLoadingFlag(true)
    }
    let params = {
      nftType: 100,
      fileType: curTab.sortName,
      offset: (page - 1) * LIMIT,
      limit: LIMIT + 1,
      sortName: curSelect.sortName,
      sortBy: curSelect.sortBy,
      onSale: +status === 1 ? 1 : undefined,
      status: canReview ? status : 1
    }
    fetchAsksSort(params)
  }
  
  // count
  const [pageCount, setPageCount] = useState(0)
  const fetchAsksSort = async (params: any, isInfo?: boolean) => {
    if (+params.fileType === 0) {
      (params.fileType as (string | number)) = ''
    }
    if (level === 'v1') {
      getArtworks(chainId as number, params, (err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        const dataAry = data.data.list || []
        const artworks = dataAry.map((d: ArtworkProps) => {
          return {
            ...d,
            tokenId: d.nftId,
            maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice,
            ...((d.price && Number(d.price)) ? {price: d.price.toString()} : {price: ''}),
            ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {auctionPrice: ''})
          }
        })
        if (isInfo) {
          if (artworks.length) {
            setArtwork(artworks[0])
          } else {
            setArtwork({...deepCopy(defaultArtworks), tokenId: tokenId, price: price, nftType: 100})
          }
        } else {
          setPageCount(Math.ceil(data.data.count / LIMIT))
          setArtworks(artworks)
        }
        setLoadingFlag(false)
      })
    } else {
      getArtworksV2(chainId as number, params, (err: any, data: any) => {
        if (err) return
        if (data.code !== 0) return
        const dataAry = data.data.list || []
        const artworks = dataAry.map((d: ArtworkProps) => {
          return {
            ...d,
            tokenId: d.nftId,
            maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice,
            ...((d.price && Number(d.price)) ? {price: d.price.toString()} : {price: ''}),
            ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {auctionPrice: ''})
          }
        })
        if (isInfo) {
          if (artworks.length) {
            setArtwork(artworks[0])
          } else {
            setArtwork({...deepCopy(defaultArtworks), tokenId: tokenId, price: price, nftType: 100})
          }
        } else {
          setPageCount(Math.ceil(data.data.count / LIMIT))
          setArtworks(artworks)
        }
        setLoadingFlag(false)
      })
    }
  }

  const updateData = useCallback((d) => {
    setCurSelect(d)
    setPage(1)
  }, [])

  const upTab = useCallback((d) => {
    setCurTab(d)
    setPage(1)
  }, [])

  useEffect(() => {
    fetchAsks(page, true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [canReview, page, curSelect, chainId, curTab, level])

  useInterval(() => {
    fetchArtworkInfo(tokenId)
    fetchAsks(page)
  }, account ? 10000 : null)

  const pageHandle = useCallback((value) => {
    setPage(value)
  }, [])

  // bake balance
  const [bakeBalance, setBakeBalance] = useState(0)
  const yam = useYam()
  const bakeryBalance = useTokenBalance(getSushiAddress(yam))
  useEffect(() => {
    const balance = getBalanceNumber(bakeryBalance)
    setBakeBalance(balance)
  }, [yam, bakeryBalance])
 
  // Allowance BAKE buy NFT
  const allowanceBuy = useAllowanceERC20(MARKETTYPE.BAKERYSOCCER)

  // 获取我的竞价
  const [requestedBid, setRequestedBid] = useState(false)
  const getBids = useUserBids(MARKETTYPE.BAKERYSOCCER)
  const emptyBids: any[] = []
  const [ids, setIds] = useState(emptyBids)
  const getIds = useCallback(async() => {
    const bids = await getBids()
    if (bids.length) {
      const bidsId = bids.map((d: any) => {
        return d[0]
      })
      setIds(bidsId)
    }
  }, [getBids])

  // 获取我的挂单
  const getAsks = useUserAsks(MARKETTYPE.BAKERYSOCCER)
  const emptyAsks: any[] = []
  const [aksIds, setAskIds] = useState(emptyAsks)
  const getAskIds = useCallback(async() => {
    const asks = await getAsks()
    if (asks.length) {
      const asksId = asks.map((d: any) => {
        return d[0]
      })
      setAskIds(asksId)
    }
  }, [getAsks])


  useEffect(() => {
    if (level === 'v2' && account) {
      getIds()
      getAskIds()
    }
  }, [getBids, getIds, getAskIds, getAsks, level, account, requestedBid, artwork])

  // v2查询是否授权卖
  const [requestedApprovalAllExchange, setRequestedApprovalAllExchange] = useState(false)
  const allowanceSellAll = useAllowanceAll(
    {
      type: MARKETTYPE.BAKERYSOCCER,
      marketFlag: 'market',
      requested: requestedApprovalAllExchange
    }
  )
  const onApproveSellAll = useApproveAllERC721(MARKETTYPE.BAKERYSOCCER, 'market')
  const handleApproveSellAll = useCallback(
    async (event) => {
      try {
        setRequestedApprovalAllExchange(true)
        const txHash = await onApproveSellAll()
        if (!txHash) {
          setRequestedApprovalAllExchange(false)
        } else {
          setTimeout(() => {
            setRequestedApprovalAllExchange(false)
          }, 10000)
        }
      } catch (e) {
        console.log(e)
      }
    },
    [onApproveSellAll, setRequestedApprovalAllExchange]
  )

  /**
   * SELL Artwork
   */
  // Approve
  const [requestedApprovalExchange, setRequestedApprovalExchange] = useState(false)
  const [resetApproval, setResetApproval] = useState(false)
  const allowanceSell = useAllowanceERC721({
    tokenId: artwork.tokenId,
    type: MARKETTYPE.BAKERYSOCCER,
    requested: requestedApprovalExchange,
    reset: resetApproval
  })
  const onApproveSell = useApproveERC721(artwork.tokenId, GETBAKERYSOCCEREXCHANGE)
  const handleApproveSell = useCallback(
    async () => {
      try {
        setRequestedApprovalExchange(true)
        const txHash = await onApproveSell()
        if (!txHash) {
          setRequestedApprovalExchange(false)
        } else {
          setTimeout(() => {
            setRequestedApprovalExchange(false)
          }, 10000)
        }
      } catch (e) {
        console.log(e)
      }
    },
    [onApproveSell, setRequestedApprovalExchange]
  )

  // Order
  const { onSell } = useSell(artwork.tokenId, MARKETTYPE.BAKERYSOCCER)
  const handleSell = async(realPrice: string) => {
    const txHash = await onSell(realPrice)
    if (txHash) {
      setUpdateNum(updateNum+1)
    }
  }

  const [artworkExchange] = useModal(
    <SellComboModal
      onConfirm={handleSell}
      tokenName="BAKE"
      title="Please set the selling price"
    />,
  )
 
  // Auction
  const { onAuction } = useAuction(artwork.tokenId, artwork.nftType?.toString())
  const [auctionkExchange] = useModal(
    <SellComboModal
      onConfirm={onSell}
      tokenName="BAKE"
      title="Please set the opening price"
      type="Auction"
      onAuction={onAuction}
    />,
  )
  const onPresentExchange = useCallback(async (event, type) => {
    if (type === 'sell') {
      artworkExchange()
    } else if (type === 'Auction') {
      auctionkExchange()
    }
  }, [artworkExchange, auctionkExchange])

  // Revoke
  const { onRevokeExchange } = useRevokeExchange(artwork.tokenId, MARKETTYPE.BAKERYSOCCER)
  const [requestedRevoke, setRequestedRevoke] = useState(false)
  const handleRevoke = useCallback(async () => {
    try {
      setRequestedRevoke(true)
      const txHash = await onRevokeExchange()
      if (!txHash) {
        setRequestedRevoke(false)
      } else {
        // reset allowanceSell
        setUpdateNum(updateNum+1)
        setResetApproval(true)
        setTimeout(() => {
          setRequestedRevoke(false)
          setResetApproval(false)
        }, 10000)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onRevokeExchange, updateNum])

  /**
   * BUY Artwork
   */
  // Approve
  const [requestedApprovalBuy, setRequestedApprovalBuy] = useState(false)
  const onApproveBuy = useApproveERC20(MARKETTYPE.BAKERYSOCCER)
  const handleApproveBuy = useCallback(async () => {
    try {
      setRequestedApprovalBuy(true)
      const txHash = await onApproveBuy()
      if (!txHash) {
        setRequestedApprovalBuy(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onApproveBuy, setRequestedApprovalBuy])

  // Buy
  const [requestedBuy, setRequestedBuy] = useState(false)
  const { onBuy } = useBuy(artwork.tokenId, MARKETTYPE.BAKERYSOCCER)
  const buyArtwork = useCallback(async () => {
    try {
      setRequestedBuy(true)
      const txHash = await onBuy()
      if (!txHash) {
        setRequestedBuy(false)
      } else {
        setUpdateNum(updateNum+1)
        // Seccussful
        if (!library) return
        library
          .getTransactionReceipt(txHash.transactionHash)
          .then(receipt => {
            if (receipt) {
              addPopup(
                {
                  txn: {
                    hash: txHash.transactionHash,
                    success: receipt.status === 1,
                    summary: 'Buy Digital Artwork NFT'
                  }
                },
                txHash.transactionHash
              )
            }
          })
          .catch(error => {
            console.error(`failed to check transaction hash: ${txHash.transactionHash}`, error)
          })
      }
    } catch (e) {
      console.log(e)
    }
  }, [onBuy, library, addPopup, updateNum])
  
  // 选择
  let defaultChecked = AuditOptions[0]
  const onSelectItem = async (e: any) => {
    defaultChecked = AuditOptions.filter(d => d.name === e.target.id)[0]
  }

  // 确认审核
  const onAudit = async (onDismiss: any, setPendingTx: any) => {
    if (!library) return
    setPendingTx(true)
    let time = Math.round(new Date().getTime()/1000).toString()
    library
      .send('eth_sign', [account, (artwork.tokenId + '-' + time)])
      .then(signature => {
        let param = {
          nftType: artwork.nftType,
          address: account,
          timestamp: time,
          nftId: artwork.tokenId,
          status: defaultChecked.value,
          signature: signature
        }
        auditArtworks(chainId as number, param, (err: any, d: any) => {
          if (err) return
          if (d.code !== 0) return
          onDismiss()
          setPendingTx(false)
        })
      })
      .catch(error => {
        setPendingTx(false)
        console.log('err', error)
      })
  }

  // 审核
  const [ReviewModal] = useModal(
    <AuditModal
      onConfirm={onAudit}
      options={AuditOptions}
      onSelectItem={onSelectItem}
      title="Review"
    />
  )

  /**
   * BID Artwork
   */
  //Approve
  const allowanceBid = useAllowanceBid(MARKETTYPE.BAKERYSOCCER)
  const [requestedApprovalBid, setRequestedApprovalBid] = useState(false)
  const onApproveBid = useApproveBid(MARKETTYPE.BAKERYSOCCER)
  const handleApproveBid = useCallback(async (event) => {
    try {
      setRequestedApprovalBid(true)
      const txHash = await onApproveBid()
      if (!txHash) {
        setRequestedApprovalBid(false)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onApproveBid, setRequestedApprovalBid])

  // 竞价
  const handBid = ((event: any) => {
    if (ids.includes(artwork.tokenId)) {
      onUpdateBid()
      return
    }
    if (aksIds.includes(artwork.tokenId)) {
      onLookBidding()
    } else {
      onBidding()
    }
  })
  // 将token卖给指定地址
  const {onSellBid} = useSellTokenTo(artwork.tokenId, MARKETTYPE.BAKERYSOCCER)
  const onSellTokenTo = useCallback(async (address: string) => {
    try {
      const txHash = await onSellBid(address)
      if (txHash) {
        setUpdateNum(updateNum+1)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onSellBid, updateNum])

  // Bidding
  const {onBid} = useBid(artwork.tokenId, MARKETTYPE.BAKERYSOCCER) 
  const {onMaxBidPrice} = useMaxBidPrice(artwork.tokenId, artwork.nftType)
  const handleBid = async (amount: string) => {
    try {
      const txHash = await onBid(amount)
      txHash && artwork.auctionPrice && await onMaxBidPrice(new BigNumber(amount).div(new BigNumber(10).pow(18)).toString())
      if (txHash) {
        setRequestedBid(true)
        setUpdateNum(updateNum+1)
      }
    } catch (e) {
      console.log(e)
    }
  }
  const [bidding] = useModal(
    <BiddingModal
      onSellTokenTo={onSellTokenTo}
      onConfirm={handleBid}
      isBidding={true}
      name={artwork.name}
      artist={artwork.author}
      tokenId={artwork.tokenId}
      type={MARKETTYPE.BAKERYSOCCER}
      auctionPrice={artwork.auctionPrice}
      />,
  )
  const onBidding = useCallback(async () => {
    bidding()
  }, [bidding])

  // 查看竞价列表
  const [lookBidding] = useModal(
    <BiddingModal
      onConfirm={onBid}
      onSellTokenTo={onSellTokenTo}
      isBidding={false}
      name={artwork.name}
      artist={artwork.author}
      tokenId={artwork.tokenId}
      type={MARKETTYPE.BAKERYSOCCER}
      auctionPrice={artwork.auctionPrice}
      />,
  )
  const onLookBidding = useCallback(async () => {
    lookBidding()
  }, [lookBidding])

  // 更新竞价
  const {onUpdate} = useUpdateBid(artwork.tokenId, MARKETTYPE.BAKERYSOCCER, artwork.auctionPrice ? onMaxBidPrice : '')
  const handleUpdate = async (amount: string) => {
    try {
      const txHash = await onUpdate(amount)
      if (txHash) {
        setUpdateNum(updateNum+1)
      }
    } catch (e) {
      console.log(e)
    }
  }
  const [updateBid] = useModal(
    <BiddingModal
      onSellTokenTo={onSellTokenTo}
      onConfirm={handleUpdate}
      name={artwork.name}
      isBidding={true}
      artist={artwork.author}
      tokenId={artwork.tokenId}
      type={MARKETTYPE.BAKERYSOCCER}
      auctionPrice={artwork.auctionPrice}
      />,
  )
  const onUpdateBid = useCallback(async () => {
    updateBid()
  }, [updateBid])

  // 移除竞价
  const cancelBid = useCancelBid(artwork.tokenId, MARKETTYPE.BAKERYSOCCER)
  const [requestedCancel, setRequestedCancel] = useState(false)
  const onCancelBid = useCallback(async(event) => {
    try {
      setRequestedCancel(true)
      const txHash = await cancelBid()
      if (!txHash) {
        setRequestedCancel(false)
      } else {
        setUpdateNum(updateNum+1)
        setTimeout(() => {
          setRequestedCancel(false)
        }, 10000)
      }
    } catch (e) {
      console.log(e)
    }
  }, [cancelBid, updateNum])

  const [imgView] = useModal(
    <ImageBig url={artwork.fileUrl}></ImageBig>
  )
  const imageLink = () => {
    window.open(artwork.attributes.image_link, '_blank')
  }
  
  return (
    <>
      <Loading open={loadingFlag} />
      <RowColumn>
        <RowColumnInfo>
          <InfoImgLabel>
            <Status status={artwork.status} />
            {
              level !== 'v1' && !ids.includes(artwork.tokenId) && Number(artwork.price) > 0 && <PriceFlag>
                <Text>{!artwork.auctionPrice ? 'On Sale' : 'On Auction'}</Text>
              </PriceFlag>
            }
            {
              level !== 'v1' && ids.includes(artwork.tokenId) && artwork.price && <PriceFlag>
                <Text>{Number(artwork.price) > 0 ? 'Offer made' : 'Order cancelled'}</Text>
              </PriceFlag>
            }
            {
              artwork.fileType === 3 ? (
                artwork.fileUrl ? <Player history={history} player={artwork} isMyArtwork={+isMyArtwork === 1 ? true : false} status={+status} canReview={canReview} type={MARKETTYPE.BAKERYSOCCER} size="true"></Player> : ''
              ) : (
                <InfoImg src={artwork.fileUrl} alt="" onClick={artwork.attributes.image_link ? imageLink : imgView}></InfoImg>
              )
            }
          </InfoImgLabel>
          <InfoRight>
            <InfoDiv>
              <Introduction artwork={artwork} />
              <HotRow>
              {
                account ? (
                  +status === 0 ? (<Button
                    onClick={ReviewModal}
                    disabled={!(canReview && artwork.name)}
                    >
                      {'Review'}
                    </Button>
                  ) : (+isMyArtwork === 1)
                    ? level !== 'v1' && ids.includes(artwork.tokenId) ?
                    <BalanceBtn>
                      <Button
                        onClick={handBid}
                        style={{
                          marginRight: 16,
                          background: theme.bg1,
                          border: `1px solid ${theme.bsText7}`,
                          color: theme.bsText7
                        }}
                      >
                        update
                      </Button>
                      <Button
                        disabled={requestedCancel}
                        onClick={onCancelBid}
                        altDisabledStyle={requestedCancel}
                      >
                        { 
                          requestedCancel ? (
                            <AutoRow gap="6px" justify="center">
                              Pending <Loader stroke="white" />
                            </AutoRow>
                          ) : (
                            'Cancel'
                          )
                        }
                      </Button>
                    </BalanceBtn>
                    : (+artwork.price > 0) ? (
                      level === 'v1' ?
                      <Button
                        disabled={requestedRevoke || !artwork.name}
                        onClick={handleRevoke}
                        altDisabledStyle={requestedRevoke || !artwork.name}
                      >
                        {
                          requestedRevoke ? (
                            <AutoRow gap="6px" justify="center">
                              Revoking <Loader stroke="white" />
                            </AutoRow>
                          ) : (
                            'Revoke'
                          )
                        }
                      </Button> :
                      <BalanceBtn>
                        <Button
                          disabled={requestedRevoke}
                          onClick={handleRevoke}
                          altDisabledStyle={requestedRevoke}
                          style={{
                            marginRight: 16
                          }}
                        >
                          { 
                            requestedRevoke ? (
                              <AutoRow gap="6px" justify="center">
                                Revoking <Loader stroke="white" />
                              </AutoRow>
                            ) : (
                              'Revoke'
                            )
                          }
                        </Button> 
                        <Button
                          onClick={handBid}
                          style={{
                            marginRight: 16
                          }}
                        >
                          <>
                            <img src={'/images/bakery/icon_bid_btn.svg'} style={{marginRight: '5px'}} alt="" />
                            {'Bidding'}
                          </>
                        </Button>
                      </BalanceBtn>
                    ) : level === 'v1' ?  allowanceSell ? (
                        <Button
                          disabled={!artwork.name}
                          onClick={event => {onPresentExchange(event, 'sell')}}
                        >Sell on Exchange</Button>
                      ) : (
                        <Button
                          onClick={handleApproveSell}
                          disabled={requestedApprovalExchange || !artwork.name}
                          fontSize={14}
                          height={40}
                          altDisabledStyle={requestedApprovalExchange || !artwork.name}
                        >
                          {requestedApprovalExchange ? (
                            <AutoRow gap="6px" justify="center">
                              Approving <Loader stroke="white" />
                            </AutoRow>
                          ) : (
                            'Approve NFT Marketplace'
                          )}
                        </Button>
                      ) : (
                        allowanceSellAll ? (
                          <BalanceBtn>
                            <Button
                              disabled={!artwork.name}
                              onClick={event => {onPresentExchange(event, 'Auction')}}
                              style={{
                                marginRight: 16,
                                background: '#FFFDFA',
                                border: '1px solid #AC562A',
                                color: '#AC562A'
                              }}
                            >
                              Auction
                            </Button>
                            <Button
                              disabled={!artwork.name}
                              onClick={event => {onPresentExchange(event, 'sell')}}
                            >Sell</Button>
                          </BalanceBtn>
                        ) : (
                          <Button
                            onClick={handleApproveSellAll}
                            disabled={requestedApprovalAllExchange}
                            fontSize={14}
                            height={40}
                            altDisabledStyle={requestedApprovalAllExchange}
                          >
                            {requestedApprovalAllExchange ? (
                              <AutoRow gap="6px" justify="center">
                                Approving <Loader stroke="white" />
                              </AutoRow>
                            ) : (
                              'Approve NFT Marketplace'
                            )}
                          </Button>
                        )
                      )
                    : artwork.price !== undefined && new BigNumber(bakeBalance).lt(!artwork.auctionPrice ? artwork.price : artwork.auctionPrice) ? (
                      level === 'v1' ?
                      <Button
                        disabled={true}
                        altDisabledStyle={true}
                      >Insufficient BAKE balance</Button>
                      : <BalanceBtn>
                          <Button
                          disabled={true}
                          altDisabledStyle={true}
                          style={{
                            marginRight: 16
                          }}
                        >
                          Insufficient BAKE balance
                        </Button>
                        <Button
                          disabled={true}
                          altDisabledStyle={true}
                        >
                          Insufficient BAKE balance
                        </Button>
                      </BalanceBtn>
                    ) : level === 'v1' ? allowanceBuy?.toNumber() ? (
                      <Button
                        onClick={buyArtwork}
                        disabled={requestedBuy || !artwork.name || noAsked}
                        altDisabledStyle={requestedBuy || !artwork.name || noAsked}
                      >{
                        requestedBuy ? (
                          <AutoRow gap="6px" justify="center">
                            Pending <Loader stroke="white" />
                          </AutoRow>
                        ) : 
                          <>
                            <img src={'/images/bakery/icon_bake_btn.svg'} style={{marginRight: '5px'}} alt="" />
                            {'Buy'}
                          </>
                      }</Button>
                    ) : (
                      <Button
                        onClick={handleApproveBuy}
                        disabled={requestedApprovalBuy || !artwork.name}
                        altDisabledStyle={requestedApprovalBuy || !artwork.name}
                      >
                        {
                          requestedApprovalBuy ? (
                            <AutoRow gap="6px" justify="center">
                              Approving <Loader stroke="white" />
                            </AutoRow>
                          ) : 'Approve NFT Marketplace'
                        }
                      </Button>
                    ) : (
                      allowanceBuy?.toNumber() && allowanceBid?.toNumber() ? (
                        !artwork.auctionPrice ? (
                          <BalanceBtn>
                            <Button
                              style={{
                                marginRight: 16
                              }}
                              onClick={buyArtwork}
                              disabled={requestedBuy || ids.includes(artwork.tokenId) || noAsked}
                              altDisabledStyle={requestedBuy || ids.includes(artwork.tokenId) || noAsked}
                            >{
                              requestedBuy ? (
                                <AutoRow gap="6px" justify="center">
                                  Pending <Loader stroke="white" />
                                </AutoRow>
                              ) : 
                              <>
                                <img src={'/images/bakery/icon_bake_btn.svg'} style={{marginRight: '5px'}} alt="" />
                                {'Buy'}
                              </>
                            }</Button>
                            <Button
                              onClick={handBid}
                              disabled={noAsked}
                              altDisabledStyle={noAsked}
                              style={{
                                marginRight: 16,
                                color: noAsked ? '' : theme.bsText9
                              }}
                            >
                              <>
                                <img src={'/images/bakery/icon_bid_btn.svg'} style={{marginRight: '5px'}} alt="" />
                                {'Bidding'}
                              </>
                            </Button>
                          </BalanceBtn>
                        ) : (
                          <Button
                            onClick={handBid}
                            disabled={noAsked}
                            altDisabledStyle={noAsked}
                            width={240}
                            style={{
                              marginRight: 16,
                              color: noAsked ? '' : theme.bsText9
                            }}
                          >
                            <>
                              <img src={'/images/bakery/icon_bid_btn.svg'} style={{marginRight: '5px'}} alt="" />
                              Bidding
                            </>
                          </Button>
                        )
                      ) : 
                      <BalanceBtn>
                        <Button
                          onClick={handleApproveBid}
                          disabled={requestedApprovalBid}
                          altDisabledStyle={requestedApprovalBid}
                          style={{
                            marginRight: 16
                          }}
                        >
                          {
                            requestedApprovalBid ? (
                              <AutoRow gap="6px" justify="center">
                                Approving <Loader stroke="white" />
                              </AutoRow>
                            ) : 'Approve NFT Marketplace'
                          }
                        </Button>
                        <Button
                          onClick={handleApproveBid}
                          disabled={requestedApprovalBid}
                          altDisabledStyle={requestedApprovalBid}
                          
                        >
                          {
                            requestedApprovalBid ? (
                              <AutoRow gap="6px" justify="center">
                                Approving <Loader stroke="white" />
                              </AutoRow>
                            ) : 'Approve NFT Marketplace'
                          }
                        </Button>
                      </BalanceBtn>
                    )
                  ) : (
                    <Button
                      onClick={toggleWalletModal}>
                      Connect Wallet
                    </Button>
                  )
                }
                {
                  account ? 
                  allowanceVote?.toNumber() ?
                    <VoteButton
                      onClick={handVote}
                      style={{
                        background: theme.bsText1,
                        border: `1px solid ${theme.bsText7}`,
                        color: theme.bsText7
                      }}
                    >
                      <>
                        <img src={'/images/bakery/icon_vote_btn.svg'} style={{marginRight: '5px'}} alt="" />
                        {'vote'}
                        <Mark></Mark>
                      </>
                    </VoteButton>
                  : 
                    <VoteButton
                      onClick={handleApproveVote}
                      disabled={requestedApprovalVote}
                      altDisabledStyle={requestedApprovalVote}
                      style={{
                        background: theme.bsText1,
                        border: `1px solid ${theme.bsText7}`,
                        color: theme.bsText7
                      }}
                    >
                      {
                        requestedApprovalVote ? (
                          <VoteAutoRow>
                            Approving <Loader stroke="white" />
                          </VoteAutoRow>
                        ) : 'Approve Vote'
                      }
                    </VoteButton>
                  : null
                }
              </HotRow>
            </InfoDiv>
            <InfoAddress artwork={artwork} type={NFTTYPE} />
          </InfoRight>
        </RowColumnInfo>
        <BidTrad>
          <BiddingList updateNum={updateNum} type={NFTTYPE} tokenId={artwork.tokenId} />
          <TradingList updateNum={updateNum} type={NFTTYPE} nftId={artwork.nftId} />
        </BidTrad>
          <TabRow margin="49px auto 36px" width="calc(100% - 40px)">
            <TextLabel style={{flex: 1}} height={37} color={theme.text1} size={22}>More Artworks</TextLabel>
            <TabRow>
              <SortPets
                margin="0 15px 0 0"
                curSelect={curTab}
                options={TabOptions}
                updateData={upTab}
              ></SortPets>
              <SortPets
                curSelect={curSelect}
                options={SortOptions}
                updateData={updateData}
              ></SortPets>
            </TabRow>
          </TabRow>
          {
            artworks.length ? (
              <>
                <ArtworksList>
                  {
                    artworks.map((d, index) => {
                      return (
                        index < LIMIT ?
                        <Artworks
                          key={d.tokenId}
                          artwork={d}
                          allowanceVote={allowanceVote}
                          status={canReview ? +status : 1}
                          canReview={canReview}
                          history={history}
                          marketType={MARKETTYPE.BAKERYSOCCER}
                        /> : ''
                      )
                    })
                  }
                  {
                    pageCount > 1 && (
                      <Paginator pageCount={pageCount} curPage={page} page={pageHandle}></Paginator>
                    )
                  }
                </ArtworksList>
              </>
            ) : !loadingFlag && <NoArtworks type={MARKETTYPE.BAKERYSOCCER} status={+status} />
          }
      </RowColumn>
    </>
  )
}
